import { useI18n } from 'next-localization';
import { GetGoogleMapAPI } from 'src/shared/GoogleMap.service';
import { FindADoctorProps } from '@ahc-digital/component-library';
import { S01FindADoctorProps } from './S01FindADoctor.types';
export function CreateFindADoctorModel(
  props: S01FindADoctorProps | undefined,
  doctorSearchURL: string,
  googleMapAPIKey: string,
  option: Record<string, string[]>
) {
  const { t } = useI18n() || {};
  const { fields } = props || {};
  return {
    specialtySelectLabel: t('FindADoctor-SelectaSpecialty'),
    specialtyItems: option,
    doctorsNameInputPlaceholder: t('FindADoctor-DoctorsName'),
    locationInputPlaceholder: t('FindADoctor-CityStateZip'),
    searchUrl: doctorSearchURL,
    googleMapsAPIKey: GetGoogleMapAPI(googleMapAPIKey),
    filterType: fields?.FilterType?.value as FindADoctorProps['filterType'],
    getPreciseLocationTriggerTitle: t('FindADoctor-GetPreciseLocationTriggerTitle'),
    doctorNameInvalidErrorMessage: t('FindADoctor-NameValidationText'),
    doctorNameRequiredErrorMessage: t('FindADoctor-DoctorNameRequiredErrorMessage'),
    legendLabel: t('FindADoctor-LegendLabel'),
    locationInvalidErrorMessage: t('FindADoctor-LocationValidationText'),
    locationRequiredErrorMessage: t('FindADoctor-CityStateZip'),
    searchAPIErrorMessage: t('FindADoctor-SearchAPIErrorMessage'),
    submitButtonTitle: t('FindADoctor-SearchText'),
  };
}
